(ns io.daskul.webapp.widgets.dashboard.ranked-table
  "Ranked table widget — top-N list with formatted columns.

   Expects a metric map with :widget :ranked-table shape:
     {:widget  :ranked-table
      :key     \"top-programs\"
      :label   \"Top Programs by Revenue\"
      :columns [{:key :name    :label \"Program\"}
                {:key :revenue :label \"Revenue\" :format :currency}]
      :rows    [{:name \"Math\" :revenue 25000}]}"
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.format :as format]))

(defn- format-cell
  "Format a cell value based on column :format."
  [value fmt]
  (case (keyword fmt)
    ;; Whole units — a ranked column is scanned, not reconciled. The symbol
    ;; comes from the same money config the forms and list columns read.
    :currency (format/format-currency (or value 0) {:decimals 0})
    :percent  (str (.toFixed (* 100 value) 1) "%")
    :number   (str value)
    (str value)))

(defui ranked-table
  "Renders a ranked table metric as a Mantine table inside a card."
  [{:keys [label columns rows]}]
  ($ ui/paper {:p "lg" :radius "md" :withBorder true}
    ($ ui/text {:size "sm" :fw 700 :mb "md"} label)
    (if (empty? rows)
      ($ ui/text {:size "sm" :c "dimmed"} "No data")
      ($ ui/table {:striped true :highlightOnHover true}
        ($ ui/thead
          ($ ui/tr
            (for [{:keys [key label format]} columns]
              ($ ui/th {:key (name key)
                        :style (when format {:textAlign "right"})}
                label))))
        ($ ui/tbody
          (for [[idx row] (map-indexed vector rows)]
            ($ ui/tr {:key idx}
              ;; The response keywordizes map keys, but a column's :key VALUE
              ;; arrives as a string ("name") while the row is keyword-keyed, so
              ;; keyword it before the lookup — else every cell reads nil.
              (for [{col-key :key col-fmt :format} columns]
                ($ ui/td {:key (name col-key)
                          :style (when col-fmt
                                   {:textAlign "right"
                                    :fontFamily "Sora, sans-serif"
                                    :fontVariantNumeric "tabular-nums"})}
                  (format-cell (get row (keyword col-key)) col-fmt))))))))))
